<!--
  A view that lays out screensaver view containing title
  and language flags
-->
<template>
  <div class="screensaver">
    <div class="screensaver__logo">
      <img
        src="@/assets/theme/images/header-logo.png"
        :alt="$t('message.headerLogoAlt')">
    </div>

    <!-- <div class="screensaver__bg_ellipse"></div> -->
    <div class="screensaver_container__content" v-show="languages.length">
        <p class="screensaver_container__title">{{$t(`${pagei18nKey}.title`)}}</p>
        <p class="screensaver_container__select">{{$t(`${pagei18nKey}.selectLanguage`)}}</p>
        <!-- Language items -->
        <ul class="screensaver_container_language_flag__items">
          <language-flag-item
            v-for="language in languages"
            v-on:selected="onLanguageSelected"
            :language="language"
            :isActive="language.id === activeIdValue"
            :key="language.id">
          </language-flag-item>
        </ul>
        <!-- Button -->
        <AppButton
          @click.native="onGetStartedClick"
          class="get_started_button"
          :state="buttonState"
          :type="buttonType"
          :text="$t(`${pagei18nKey}.getStarted`)" />
    </div>
  </div>
</template>
<script>
  import AppButton, {ButtonStates, ButtonTypes} from '@/components/app-button'
  import api from '@/api/api'
  import LanguageFlagItem from '@/components/language-flag-item'
  import { loadLanguageAsync } from '@/lang'
  import { Validator } from 'vee-validate'

  export default {
    components: {
      LanguageFlagItem,
      AppButton
    },
    name: 'screensaver-view',
    data: function () {
      return {
        initialActiveId: null,
        pagei18nKey: 'message.screensaver',
        appTitle: this.$route.meta.appTitle,
        languages: [],
        buttonState: ButtonStates.ENABLED,
        buttonType: ButtonTypes.SECONDARY
      }
    },
    computed: {
      activeIdValue: {
        /**
         * Gets current stored language
         */
        get () {
          // language not stored, no default value,
          // but we have languages list - assume first language default
          if (!this.$store.getters.language.id && this.languages.length > 0) {
            return this.languages[0].id
          }
          // all ok, get it from store
          return this.$store.getters.language.id
        }
      }
    },
    methods: {
      /**
       * Set language and send to next view
       *
       * @param {Object} language - Selected language object
       */
      onLanguageSelected: function (language) {
        // save the language in our global state
        this.$store.commit('setLanguage', language)
        Validator.localize(language.languageIsoCode)
        loadLanguageAsync(language.languageIsoCode).then(() => {
          console.log(language.languageIsoCode + ' strings loaded')
        })
      },
      /**
       * Click on get started button
       */
      onGetStartedClick: function () {
        // Timeout with 0 is used here to allow for a re-render to happen
        // so that the language item active state can update before moving on
        setTimeout(() => {
          this.$router.push('/data-protection')
        }, 0)
      }
    },
    beforeCreate () {
      // copy current language id into variable to revert it after form clear
      var language = this.$store.getters.language
      this.$store.commit('resetState')
      this.$store.commit('setLanguage', language)
    },
    mounted () {
      api.getLanguages()
        .then(response => {
          this.languages = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";

  // values like 100-110vh should work fine.
  // but now it's the same on all screens when set 1300px
  $screensaver-ellipse-size: 100%;
  $screensaver-container-title-line-height: $large-line-height * 4;

  .screensaver__logo {
    text-align: center;
    margin-top: 66px;
    // Adding display block to a responsive image stops the weird spacing
    // underneath the image inside the parent
    img {
      height: $dims-header-logo-height;
    }
  }

  .screensaver__bg_ellipse {
    background-color: $primary-brand-color;
    opacity: .6;
    width: $screensaver-ellipse-size;
    height: $screensaver-ellipse-size;
    top: 16%;
    right: 0;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: $screensaver-ellipse-size / 2;
    position: absolute;
  }

  .screensaver_container__content {
    // top: 35%;
    width: 100%;
    height: 100%;
    text-align: center;
    // position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;

    .screensaver_container__title {
      margin: 300px $dims-spacing-small 0 $dims-spacing-small;
      font-size: $large-font-size * 4;
      line-height: $screensaver-container-title-line-height;
      color: $secondary-brand-color;
      height: $screensaver-container-title-line-height * 3; // allow 3 lines
    }

    .screensaver_container__select {
      position: absolute;
      bottom: 280px;
      font-size: $small-font-size * 2;
      margin-top: 0;
      color: $secondary-brand-color;
    }

    .screensaver_container_language_flag__items {
      position: absolute;
      bottom: 220px;
      display: flex;
      justify-content:center;
      align-items: center;

    }

    .get_started_button {
      position: absolute;
      bottom: 100px;
      width: 220px;
      padding: $dims-spacing-small $dims-spacing-large;
      color: $primary-brand-color;
      display: inline-block;
    }
  }
</style>
